
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/airlines/news",
      function () {
        return require("private-next-pages/airlines/news.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/airlines/news"])
      });
    }
  